import logo from './logo.svg';
import './App.css';
// import Navbar from './components/SideNav/SideNav'
import HomePage from './components/HomePage/HomePage';
function App() {
  // const VerticalTab=VerticalTabs;
  return (
    <div className="App">
      <HomePage></HomePage>
    </div>
  );
}

export default App;
